import Vue from 'vue';
import BudgetStatus from '@/Enums/BudgetStatus';
import ProfitAndLossStatus from '@/Enums/ProfitAndLossStatus';
import CalculatedBy from '@/Enums/CalculatedBy';
window.BudgetStatus = BudgetStatus;
window.ProfitAndLossStatus = ProfitAndLossStatus;
window.CalculatedBy = CalculatedBy;
Vue.prototype.$budgetStatus = BudgetStatus;
Vue.prototype.$profitAndLossStatus = ProfitAndLossStatus;
Vue.prototype.$calculatedBy = CalculatedBy;
